import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/authProvider';
import { useDefaultRoute } from '../../hooks/useDefaultRoute';

export const DefaultRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const defaultRoute = useDefaultRoute();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (defaultRoute) {
    return <Navigate to={defaultRoute} replace />;
  }

  return <Navigate to="/access-denied" replace />;
};
